export default __webpack_public_path__ + "locales/sr-Latn-RS/InfoPanel.json?hash=fda504d6be22db347ddb32e1822c8adc";